// removed by extract-text-webpack-plugin
module.exports = {"root":"form__root___19oWg","main":"form__main___2yNv_"};